import { Col, Row, Form } from 'antd';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import tokens from '../../../utils/tokens';
import SelectWithRequest from './SelectWithRequest';

const InputGeo = ({ form, countryName, regionName, cityName, required }) => {
  const [country, setCountry] = useState(form.getFieldValue(countryName));
  const [region, setRegion] = useState(form.getFieldValue(regionName));

  const onCountryChange = (newCountry) => {
    setCountry(newCountry);
    form.setFieldsValue([{ name: regionName, value: undefined }]);
    form.setFieldsValue([{ name: cityName, value: undefined }]);
    setRegion(undefined);
  };

  const onRegionChange = (newRegion) => {
    setRegion(newRegion);
    // eslint-disable-next-line no-unused-vars
    const a = [{ name: cityName, value: undefined }];
    form.setFieldsValue([{ name: cityName, value: undefined }]);
  };

  return (
    <Row gutter={[tokens.forms.horizontalGutterInPx]}>
      <Col lg={12} xs={24}>
        <Form.Item label="País" name={countryName} rules={[{ required }]}>
          <SelectWithRequest
            url="/params/countries"
            onChange={onCountryChange}
            autoComplete="none"
          />
        </Form.Item>
      </Col>
      {country === 'CHILE' && (
        <>
          <Col lg={12} xs={24}>
            <Form.Item label="Región" name={regionName} rules={[{ required }]}>
              <SelectWithRequest
                url={`/params/regions?country=${country}`}
                onChange={onRegionChange}
                autoComplete="none"
              />
            </Form.Item>
          </Col>
          <Col lg={12} xs={24}>
            <Form.Item label="Comuna" name={cityName} rules={[{ required }]}>
              <SelectWithRequest url={`/params/cities?region=${region}`} autoComplete="none" />
            </Form.Item>
          </Col>
        </>
      )}
    </Row>
  );
};

InputGeo.propTypes = {
  form: PropTypes.shape().isRequired,
  countryName: PropTypes.string.isRequired,
  regionName: PropTypes.string.isRequired,
  cityName: PropTypes.string.isRequired,
  required: PropTypes.bool,
};

InputGeo.defaultProps = {
  required: false,
};

export default InputGeo;
